import { MouseEvent } from "react";
import "../../ui/elements/button.scss";

type ButtonProps = {
  children: string;
  onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
  type?: "button" | "submit" | "reset";
  unactive?: boolean;
  className?: string;
};

export const Button = ({
  children,
  onClick,
  type = "button",
  unactive = false,
  className = "",
}: ButtonProps) => {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={unactive}
      className={`button${unactive ? " button--unactive" : ""}${className ? ` ${className}` : ""}`}
    >
      {children}
    </button>
  );
};
